export default {
  title: 'Allergeni',
  options: {
    dairy: 'Latticini/Latte',
    eggs: 'Uova',
    fish: 'Pesce',
    gluten: 'Glutine',
    mango: 'Mango',
    peanuts: 'Arachidi',
    sesame: 'Sesamo',
    shellfish: 'Frutti di mare',
    soy: 'Soia',
    tree_nuts: 'Frutta a guscio',
    celery: 'Sedano',
    crustaceans: 'Crostacei',
    lupin: 'Lupino',
    molluscs: 'Molluschi',
    mustard: 'Senape',
    nuts: 'Noci',
    sulphites: 'Solfiti',
    almonds: 'Mandorle',
    barley: 'Orzo',
    brazil_nuts: 'Noci del Brasile',
    cashew: 'Anacardi',
    hazelnuts: 'Nocciole',
    kamut: 'Kamut',
    macadamia: 'Noci di macadamia',
    oats: 'Avena',
    pecan: 'Noci pecan',
    pistachios: 'Pistacchi',
    rye: 'Segale',
    spelt: 'Farro',
    walnuts: 'Noci',
    wheat: 'Frumento',
    sugared_drink: 'Bevanda zuccherata',
    lentils: 'Lenticchie',
    queensland_nuts: 'Noci del Queensland',
  },
};
